export default "__VITE_ASSET__BzBS_7C7__"